import Button from 'components/ui/Button';
import InputTextField from 'components/ui/InputTextField';
import React, { useEffect, useState } from 'react'
import { IoIosMail } from 'react-icons/io';
import { RiLockFill } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { USER_LOGIN } from '../../../../redux/types/auth.types';
import { authActions } from '../../../../redux/slice/auth.slice';

const LoginForm = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
   const [loginData , setLoginData ]= useState({
    email : "",
    password : "",
    isRememberMe : false
   }) 

   const auth = useSelector(authActions.selectors.getLoggedInStatus);

   useEffect(()=>{
    if(auth){
        navigate('/')
    }
   },[auth, navigate])



    const handleLoginUpForm = (name, value) => {
        setLoginData({
            ...loginData,
            [name]: value
        })
    }
    const signUpPageHandler = () => {
        navigate("/sign-up")
    }

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch({type : USER_LOGIN , payload : loginData})
    }

    const forgetPageHandler = () => {
        navigate("/navigate")
    }

    return (
        <form className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32" onSubmit={submitHandler}>
            <div className="text-3xl font-bold">Log In</div>
            <div className="mt-3 text-lg text-lightGrey">
                Welcome back! Please enter your details.
            </div>
            <div className="mt-6">
                <InputTextField
                    label="Email*"
                    type="text"
                    icon={<IoIosMail size={24} />}
                    placeholder="Enter your email address"
                    onChange={handleLoginUpForm}
                    name="email"
                    required={true}
                />
            </div>
            <div className="mt-1 ">
                <InputTextField
                    label="Password*"
                    type="password"
                    id="Password"
                    icon={<RiLockFill size={24} />}
                    placeholder="Password"
                    onChange={handleLoginUpForm}
                    name="password"
                    required={true}
                />
            </div>
            <div className="flex justify-between items-center mt-2 text-xs font-semibold">
                <div className="flex items-center gap-2">
                    <input type="checkbox" onChange={(e) => handleLoginUpForm("isRememberMe" , e.target.checked)} className="h-4 w-4 rounded-me" />
                    <div>Remember me</div>
                </div>
                <div className="text-[#33C3DF] flex items-center ">
                    <a href="/forget-password" onClick={forgetPageHandler}>Forgot Password?</a>
                </div>
            </div>
            <div className="mt-6">
                <Button title="Log In" type="submit" />
            </div>
            <div className="mt-3 flex text-xs font-semibold gap-1">
                <div className="text-lightGrey">Not member yet?</div>
                <div className="text-secondary cursor-pointer" onClick={signUpPageHandler}>Create an account</div>
            </div>
        </form>
    )
}

export default LoginForm